import { Component, EventEmitter, Input, Output } from "@angular/core";
import { Organization } from "@onsip/common/services/api/resources/organization/organization.service";

@Component({
  selector: "onsip-default-caller-id-view",
  templateUrl: "./default-caller-id-view.component.html",
  styleUrls: ["./default-caller-id-view.component.scss"],
  standalone: false
})
export class DefaultCallerIdViewComponent {
  @Input() organization!: Organization;
  @Output() editPanel = new EventEmitter<void>();

  togglePanel() {
    this.editPanel.emit();
  }
}
